export default __webpack_public_path__ + "static/media/img35.845d104d.jpg";